import { render } from "./SubscriptionSubDetails.vue?vue&type=template&id=17944169&ts=true"
import script from "./SubscriptionSubDetails.vue?vue&type=script&lang=ts"
export * from "./SubscriptionSubDetails.vue?vue&type=script&lang=ts"

import "./SubscriptionSubDetails.vue?vue&type=style&index=0&id=17944169&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__